import moment from 'moment';

export const STOP_STATUS = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  PARTIALLY_DELIVERED: 'PARTIALLY_DELIVERED',
  DELIVERED: 'DELIVERED',
  REDELIVERED: 'REDELIVERED',
  UNDELIVERED: 'UNDELIVERED',
  CANCELED: 'CANCELED'
};

export const STOP_TOOLTIP_CONFIG = {
  direction: 'right',
  offset: [0, 50],
  className: 'stop-detail-tooltip'
};

export const STOP_STATUS_RESOURCE = {
  [STOP_STATUS.PENDING]: 'Greenmile.Stop.IconDescription.pending',
  [STOP_STATUS.DELIVERED]: 'Greenmile.Stop.IconDescription.completed',
  [STOP_STATUS.PARTIALLY_DELIVERED]:
    'Greenmile.Stop.IconDescription.partiallyDelivered',
  [STOP_STATUS.REDELIVERED]: 'Greenmile.Stop.IconDescription.redelivery',
  [STOP_STATUS.UNDELIVERED]: 'Greenmile.Stop.IconDescription.undeliverable',
  [STOP_STATUS.CANCELED]: 'Greenmile.Stop.IconDescription.cancel',
  [STOP_STATUS.IN_PROGRESS]: 'Greenmile.Stop.IconDescription.inProgress'
};

export const getStopStatus = (stop) => {
  if (!stop) return null;

  if (stop?.cancelCode) return STOP_STATUS.CANCELED;

  if (!stop.deliveryStatus && !stop.actualArrival && !stop.actualDeparture) {
    return STOP_STATUS.PENDING;
  }

  return stop.deliveryStatus;
};

export const getStopStatusResourceByStatus = (status) => {
  if (!status) return null;

  return STOP_STATUS_RESOURCE[status.toUpperCase()] || null;
};

export const formatNextStopMessageTooltip = (projectedArrival) => {
  if (!projectedArrival) return '';
  const formattedDate = moment(projectedArrival).format('HH:mm');
  const text = Monet.I18n.getResourcesByKey('NextStop.To.Be.Attended.Around');

  return `${text} ${formattedDate}`;
};
